import { render, staticRenderFns } from "./component-recommend.vue?vue&type=template&id=27ad463e&scoped=true&"
import script from "./component-recommend.vue?vue&type=script&lang=js&"
export * from "./component-recommend.vue?vue&type=script&lang=js&"
import style0 from "./component-recommend.vue?vue&type=style&index=0&id=27ad463e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad463e",
  null
  
)

export default component.exports